
import { Typography } from '@material-ui/core';
import React from 'react';

const BankLastschriftErteilen: React.FC = () => {

    return (
        <Typography variant='caption' color='textPrimary'>
            Mit dem Abschluss ermächtige ich die vertragsführende RheinLand Versicherungs AG
            alle Forderungen zu diesem Vertrag bei Fälligkeit von meinem oben genannten Konto
            mittels SEPA-Lastschrift einzuziehen.
        </Typography>

    );
}

export default BankLastschriftErteilen;